export type RegistrationToken = {
  id?: string;
  userId: string;
  registrationToken: string;
};
